import { useMutation, useQuery } from '@apollo/client';
import {
  ALL_MODULES,
  AccessControl,
  AppContext,
  DEFAULT_FIELDS_BY_COLUMN_NAME,
  EventEmitter,
  Loader,
  TICKET_SOURCE,
  getBrowserType,
  useIntl,
  useIsAuthorisedHook,
  useUserMSPCheckHook,
  withErrorBoundary
} from '@nile/components/src';
import {
  AccountClient,
  GET_DEFAULT_REPLY_TEMPLATE,
  GET_FIELD,
  GET_STATUS_CONFIGURATION,
  GET_TICKET_AUDIT_LIST,
  TicketClient,
  useCachedQuery
} from '@nile/graphql';
import { GET_TICKET_REPLY_RECIPEINTS } from '@nile/graphql/src/Query/ticket';
import envConfig from '@nile/home/src/Config/env';
import {
  ActionToolbar,
  ApprovalBubble,
  ConversationBubbleNew,
  ThreadConversationBubble,
  CreatedByBubble,
  NoteBubbleNew,
  SideConversationNotificationBubble,
  ChatUpdateBubble
} from '@nile/mangifera/src/Components/Chat';
import { TicketContext } from '@nile/mangifera/src/Contexts';
import { getTabId } from '@nile/mangifera/src/Pebbles/TabManager';
import { isEmpty } from 'lodash';
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState
} from 'react';
import { ViewportList } from 'react-viewport-list';
import '@nile/components/src/Style/ticketDetailsStyles.scss';
import styled from 'styled-components';
import ConversationEditorContainer from './ConversationEditorContainer';
import NoteEditorContainer from './NoteEditorContainer';
import TicketConversationEmptyState from './TicketConversationEmptyState';
import ApprovalWidget from './ApprovalWidget';
import TicketConversationActions from '@nile/mangifera/src/Containers/ChatContainers/TicketConversationActions.tsx';
import '@nile/components/src/Style/ticketDetailsStyles.scss';
import { useGlobalChatHook } from '@nile/components/src/Components/GlobalChatHook';
import { CREATE_AI_FEATURE_FEEDBACK } from '@nile/banyan/src/Graphql/Mutations/ai';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useTicketDetailsConversationStore } from '@nile/mangifera/src/StoreManager/store/ticketDetailsConversationStore';

let broadcastChannel;
if (BroadcastChannel) {
  broadcastChannel = new BroadcastChannel('SuperShare');
}

const StyledConversation = styled.div`
  background-image: url(${envConfig.imageRoot}svg/chatBg.svg);
`;

const conversationTypeMap = {
  conversation: 'conversation',
  note: 'note'
};

let typingInterval;
let statusTimer;

const ChatFeedContainerNew = (props) => {
  const {
    ticketId,
    client,
    createdBy,
    requester,
    createdTime,
    switchToConnect,
    createNewSideConversation,
    sop,
    status,
    source,
    additionalRequester,
    updateTicketStatus,
    filterBy,
    updateNumber,
    concurrentUsersTyping,
    setFailureConversationData,
    setUpdateTabCount,
    readOnly,
    subject,
    displayId,
    AIPrompts,
    imConfig
  } = props;
  const intl = useIntl();
  const flags = useFlags();
  const ticketConversationUx = flags?.ticketConversationUx;

  const appContext = useContext(AppContext);
  const currentUser = appContext?.user || {};
  const context = useContext(TicketContext);
  const browserType = getBrowserType();
  const isSafari = browserType === 'Apple Safari';

  const conversationOrder = appContext?.conversationOrder || 'ASC';
  const isMSP = useUserMSPCheckHook();

  const listRef = React.useRef(null);
  const chatFeedContainerRef = React.useRef(null);

  const renderCreatedBubble =
    createdBy?.email &&
    requester?.email &&
    createdBy?.email !== requester?.email;

  const createdBubbleProp = renderCreatedBubble
    ? {
        message: 'ticket.details.conversations.createdBy',
        isSend: false,
        id: 'ticketCreatedBy',
        authorId: 'system',
        type: 'createdBy',
        user: createdBy,
        ticketId: ticketId,
        time: createdTime
      }
    : null;

  const BUBBLE_TYPES = {
    NOTE: 'NOTE',
    CONVERSATION: 'CONVERSATION',
    VENDOR_CONVERSATION: 'VENDOR_CONVERSATION',
    APPROVAL: 'APPROVAL',
    CONVERSATION_THREAD: 'CONVERSATION_THREAD',
    THREAD_CONVERSATION: 'THREAD_CONVERSATION'
  };

  const Bubbles = {
    NOTE: NoteBubbleNew,
    CONVERSATION: ConversationBubbleNew,
    VENDOR_CONVERSATION: SideConversationNotificationBubble,
    APPROVAL: ApprovalBubble,
    CONVERSATION_THREAD: ChatUpdateBubble,
    THREAD_CONVERSATION: ThreadConversationBubble
  };

  const [showEmailSent, setShowEmailSent] = useState(null);

  const activeTabIndex = useTicketDetailsConversationStore(
    (s) => s.activeTabIndex
  );

  const conversationMode = useTicketDetailsConversationStore(
    (s) => s.conversationMode
  );

  const setConversationMode = useTicketDetailsConversationStore(
    (s) => s.setConversationMode
  );

  const editNoteData = useTicketDetailsConversationStore((s) => s.editNoteData);
  const editNoteId = editNoteData?.noteId;

  const [allStatus, setAllStatus] = useState([]);
  const { getGlobalConversations } = useGlobalChatHook();

  const globalState = getGlobalConversations();
  const [isActionContainerDisabled, setIsActionContainerDisabled] = useState(
    false
  );

  const globalChats = [...globalState];

  const checkIfActionToolbarDisabled = (conversation) => {
    if (conversation) {
      const actionsDisabled = conversation?.id === ticketId;
      setIsActionContainerDisabled(actionsDisabled);
    }
  };

  const onGlobalConversationClose = (chat) => {
    if (!ticketConversationUx) {
      if (chat?.id === ticketId) {
        setIsActionContainerDisabled(false);
        if (activeTabIndex !== 2) {
          setConversationMode('conversation');
        }
      }
    }
  };

  const checkHideGlobalTicketConversationCloseModal = (chat, tabContext) => {
    const activeTicketId = tabContext?.activeTab?.data?.ticketId;
    return activeTicketId === chat?.id;
  };

  const openTicketFromGlobalConversation = (chat, tabContext) => {
    const ticket = chat?.data;
    tabContext.openTicket({
      module: 'TICKET',
      ticketId: ticket.ticketId,
      data: {
        subject: ticket.subject,
        displayId: ticket.displayId,
        ticketId: ticket.ticketId
      }
    });
  };

  const [
    sendAIFeatureFeedback,
    { loading: aiFeatureFeedbackLoading }
  ] = useMutation(CREATE_AI_FEATURE_FEEDBACK, {
    client: AccountClient,
    onCompleted(res) {
      console.log(res, 'ash:: AI feature feedback res');
    }
  });

  const focusLastAddedMessage = useCallback(() => {
    if (conversationOrder === 'ASC') {
      if (listRef.current?.scrollHeight) {
        // The height will not change immediately after state update so I'm adding a small set timeout
        setTimeout(() => {
          listRef.current.scrollTo({
            top: listRef.current?.scrollHeight + 100,
            behavior: 'smooth'
          });
        }, 1);
      }
    } else {
      listRef.current.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [conversationOrder, listRef.current]);

  useEffect(() => {
    const isTicketConversationPresent = globalChats?.find(
      (el) => el?.id === ticketId
    );
    if (isTicketConversationPresent) {
      checkIfActionToolbarDisabled(isTicketConversationPresent);
    }
    EventEmitter.subscribe(
      'globalConversationClosed',
      onGlobalConversationClose
    );
    EventEmitter.subscribe('focusLastAddedMessage', focusLastAddedMessage);
    return function cleanup() {
      EventEmitter.unsubscribe('globalConversationClosed');
      EventEmitter.unsubscribe('focusLastAddedMessage');
    };
  }, []);

  const CONVERSATION_VARIABLES = useMemo(() => {
    return {
      input: {
        ticket: { ticketId: ticketId },
        listInfo: {
          sort: {
            attribute: 'time',
            order: conversationOrder
          },
          condition: {
            joinOperator: 'AND',
            operands: [
              {
                attribute: 'type',
                operator: 'isNot',
                value: 'TASK'
              }
            ]
          }
        }
      }
    };
  }, [ticketId, conversationOrder]);

  const {
    loading: feedsLoading,
    data: feed,
    refetch: refetchFeeds
  } = useCachedQuery(GET_TICKET_AUDIT_LIST, {
    variables: CONVERSATION_VARIABLES
  });

  const feeds = feed?.getTicketAuditList?.ticketAudit;

  const getFeedsToDisplay = useCallback(() => {
    if (filterBy) {
      return feeds?.filter((el) => filterBy?.includes(el?.type));
    }
    return feeds;
  }, [feeds, filterBy]);

  const feedsToDisplay = getFeedsToDisplay();

  const allFeedsRef = React.useRef(feedsToDisplay);
  allFeedsRef.current = feedsToDisplay;

  useEffect(() => {
    // UseEffect ot update tab count
    if (feeds && feeds?.length) {
      let notesLength = 0;
      let conversationLength = 0;

      feeds.forEach((el) => {
        if (
          el?.type === 'CONVERSATION' ||
          (source === TICKET_SOURCE.Communication &&
            el?.type === 'THREAD_CONVERSATION')
        ) {
          conversationLength++;
        } else if (el?.type === 'NOTE') {
          notesLength++;
        }
      });

      setUpdateTabCount?.(feeds.length);
      updateNumber('note', notesLength);
      updateNumber('conversation', conversationLength);
    }
  }, [feeds, source]);

  useEffect(() => {
    // Find ways to remove it.
    // Used in tabs list, merge ticket sheet, GlobalConversation action and Insights (Ticket insights)
    EventEmitter.subscribe('refetchTicketAudit', () => {
      refetchFeeds();
    });
    return () => EventEmitter.unsubscribe('refetchTicketAudit');
  }, [refetchFeeds]);

  const isEditAuthorised = useIsAuthorisedHook('tickets.edit');
  const isStatusAuthorised = useIsAuthorisedHook('customFields.view');

  const getIsTicketEditAuthorised = useCallback(() => {
    if (isMSP) {
      return isEditAuthorised;
    }
    return true;
  }, []);

  const updateConversationState = (conversation) => {
    if (!conversation || !conversation?.conversationId) {
      return;
    }

    TicketClient.cache.modify({
      fields: {
        getTicketAuditList(existing = {}, { readField }) {
          const existingFeeds = existing.ticketAudit || [];

          let isUpdated = false;
          const updatedFeeds = existingFeeds.map((currentFeed) => {
            if (
              currentFeed?.type === 'CONVERSATION' ||
              currentFeed?.type === 'THREAD_CONVERSATION'
            ) {
              const accessor =
                currentFeed?.type === 'CONVERSATION'
                  ? 'conversation'
                  : 'threadConversation';
              const feedData = readField(accessor, currentFeed);
              if (feedData?.conversationId === conversation?.conversationId) {
                isUpdated = true;
                const updatedFeedData = { ...feedData };
                if (currentFeed?.type === 'THREAD_CONVERSATION') {
                  if (conversation?.conversationStatus) {
                    updatedFeedData.conversationStatus =
                      conversation.conversationStatus;
                  }
                } else {
                  if (conversation?.outgoingMailFailureReason) {
                    updatedFeedData.outgoingMailFailureReason =
                      conversation.outgoingMailFailureReason;
                  }
                  if (conversation?.outgoingMailStatus) {
                    updatedFeedData.outgoingMailStatus =
                      conversation.outgoingMailStatus;
                  }
                }
                isUpdated = true;
                return updatedFeedData;
              }
            }
            return currentFeed;
          });

          if (!isUpdated) {
            refetchFeeds();
          } else {
            return {
              ...existing,
              ticketAudit: updatedFeeds
            };
          }
        }
      }
    });
  };

  const changeConversationProperties = (conversation) => {
    const formatUserObj = (users) => {
      return users?.map((user) => {
        if (user.user.email === conversation.emailAddress) {
          return {
            ...user,
            mailDeliveryStatus: conversation?.mailDeliveryStatus,
            // mailDeliveryMessage: JSON.parse(conversation?.mailDeliveryMessage),
            mailFailureReason: {
              ...user?.mailFailureReason,
              reason: JSON.parse(conversation?.mailDeliveryMessage)?.reason
            }
          };
        }
        return user;
      });
    };

    TicketClient.cache.modify({
      fields: {
        getTicketAuditList(existing = {}, { readField }) {
          const existingFeeds = existing.ticketAudit || [];
          let isUpdated = false;

          const updatedFeeds = existingFeeds.map((conversationFeed) => {
            const feedId = readField(
              'conversation.conversationId',
              conversationFeed
            );
            if (feedId === conversation?.conversationId) {
              isUpdated = true;
              return {
                ...conversationFeed,
                conversation: {
                  ...conversationFeed?.conversation,
                  toUsers: formatUserObj(
                    conversationFeed?.conversation?.toUsers
                  ),
                  bccUsers: formatUserObj(
                    conversationFeed?.conversation?.bccUsers
                  ),
                  ccUsers: formatUserObj(
                    conversationFeed?.conversation?.ccUsers
                  )
                }
              };
            }
            return conversationFeed;
          });

          if (!isUpdated) {
            refetchFeeds();
          } else {
            return {
              ...existing,
              ticketAudit: updatedFeeds
            };
          }
        }
      }
    });
  };

  const changeConversationStatus = (conversation) => {
    // let updatedFeed = null;
    // feeds.forEach((feeed) => {
    //   if (
    //     feeed?.conversation?.conversationId === conversation?.conversationId &&
    //     feeed?.type === 'CONVERSATION'
    //   ) {
    //     updatedFeed = {
    //       ...feeed,
    //       conversation: {
    //         ...feeed?.conversation,
    //         outgoingMailStatus: conversation?.outgoingMailStatus
    //       }
    //     };
    //   } else if (
    //     feeed?.threadConversation?.conversationId ===
    //       conversation?.conversationId &&
    //     feeed.type === 'THREAD_CONVERSATION'
    //   ) {
    //     updatedFeed = {
    //       ...feeed,
    //       threadConversation: {
    //         ...feeed?.threadConversation,
    //         conversationStatus: conversation?.conversationStatus
    //       }
    //     };
    //   }
    // });
    updateConversationState(conversation);
  };

  const showTicketEditorContainer = getIsTicketEditAuthorised();

  const errorStatuses = ['BOUNCED', 'DROPPED', 'BLOCKED'];

  broadcastChannel.onmessage = (event) => {
    const eventData = JSON.parse(event.data);
    if (eventData?.payload?.type === 'SERVER_EVENT') {
      const { context, payload } = eventData;
      const conversation = payload?.data?.conversation;
      if (
        context === 'pageUpdate' &&
        payload?.event === 'UPDATE_CONVERSATION' &&
        !payload?.showToast &&
        conversation?.workItem.workId === ticketId
      ) {
        if (
          conversation?.outgoingMailStatus === 'SUCCESS' ||
          conversation?.conversationStatus === 'SENT'
        ) {
          setShowEmailSent(conversation?.conversationId);
          if (statusTimer) clearTimeout(statusTimer);
          statusTimer = setTimeout(() => {
            setShowEmailSent(null);
            changeConversationStatus(conversation);
          }, 1000);
        } else if (errorStatuses.includes(conversation?.mailDeliveryStatus)) {
          changeConversationProperties(conversation);
          // conversation.
        } else {
          // if (conversation?.outgoingMailStatus === 'FAILURE') {
          changeConversationStatus(conversation);
        }
      }
    }
  };

  const {
    loading: ticketStatusConfigLoading,
    data: statusConfigData
  } = useQuery(GET_STATUS_CONFIGURATION, {
    skip: !isStatusAuthorised,
    fetchPolicy: 'cache-and-network'
  });

  const { loading: ticketStatusesLoading } = useCachedQuery(GET_FIELD, {
    client: AccountClient,
    skip: !isStatusAuthorised,
    variables: {
      input: {
        module: ALL_MODULES.ticket,
        columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.STATUS
      }
    },
    onCompleted(res) {
      const fldOptions =
        res?.getField?.options || res?.getField?.fieldOptions || [];
      const statusData = fldOptions?.map((el) => ({
        id: el?.id,
        name: el?.value
      }));
      setAllStatus(statusData);
    }
  });

  useEffect(() => {
    if (props?.sendClientEvent) {
      if (conversationMode === conversationTypeMap.conversation) {
        props.sendClientEvent('TYPING_CONVERSATION', props?.ticketId);
        typingInterval = setInterval(() => {
          props.sendClientEvent('TYPING_CONVERSATION', props?.ticketId);
        }, 3000);
      }
      if (
        typingInterval &&
        conversationMode !== conversationTypeMap.conversation
      ) {
        clearInterval(typingInterval);
        typingInterval = undefined;
        props.sendClientEvent('STOPPED_TYPING_CONVERSATION', props.ticketId);
      }
    }
  }, [conversationMode]);

  const getEditNoteIndex = () => {
    const index = allFeedsRef.current.findIndex(
      (f) => f?.note?.noteId === editNoteId
    );
    return index;
  };

  const getIntialIndex = () => {
    if (!editNoteId) {
      if (conversationOrder === 'ASC') {
        return {
          initialIndex: allFeedsRef.current.length - 1,
          initialAlignToTop: false
        };
      }
      return { initialIndex: -1, initialAlignToTop: true };
    }
    return {
      initialIndex: getEditNoteIndex(),
      initialAlignToTop: true
    };
  };

  const getExtraProps = useCallback(() => {
    const initialIndexProps = getIntialIndex();
    if (conversationOrder === 'ASC') {
      return {
        ...initialIndexProps,
        margin: 40,
        initialOffset: 40
      };
    }
    return initialIndexProps;
  }, [conversationOrder]);

  const getBubbleProps = (type, feedData) => {
    switch (type) {
      case BUBBLE_TYPES.NOTE:
        return {
          client: client
        };
      case BUBBLE_TYPES.VENDOR_CONVERSATION:
        const message = {
          data: feedData?.vendorConversation,
          messageType: feedData?.vendorConversation?.type,
          id: feedData?.id,
          time: feedData?.time
        };
        return {
          message: message,
          switchToConnect: switchToConnect
        };

      case BUBBLE_TYPES.APPROVAL:
        const approvalMessageData = {
          data: feedData?.approval,
          user: feedData?.user,
          messageType: feedData?.approval?.status,
          time: feedData?.time
          // Need to check message for comment inside bubble and sentOn
          // message: ??
          // sentOn: //
        };
        return {
          message: approvalMessageData
        };
      default:
        return {};
    }
  };

  const scrollIntoView = useCallback(() => {
    if (conversationOrder === 'ASC') {
      const timer = setTimeout(() => {
        const scrollHeight = chatFeedContainerRef.current.scrollHeight + 2000;
        chatFeedContainerRef.current.scroll({
          top: scrollHeight,
          behavior: 'smooth'
        });
      }, 100);
      // clearTimeOut(timer);
    }
  }, []);

  const onActionClick = useCallback(
    (mode) => {
      setConversationMode(mode);
      if (mode) {
        scrollIntoView();
      }
    },
    [setConversationMode, scrollIntoView]
  );

  const resetConversationMode = useCallback(() => {
    if (activeTabIndex === 0) {
      setConversationMode(null);
    }
  }, [activeTabIndex, setConversationMode]);

  const sendAgentCollisionDataFromFloatingEditor = () => {
    if (props?.sendClientEvent) {
      props.sendClientEvent('REGISTER_PAGE', props?.ticketId);
      props.sendClientEvent('TYPING_CONVERSATION', props?.ticketId);
      setTimeout(() => {
        props.sendClientEvent('STOPPED_TYPING_CONVERSATION', props.ticketId);
      }, 5000);
    }
  };

  if (isEmpty(feed) && feedsLoading) {
    return <Loader />;
  }

  const conversationClass = `conversationOrder-${conversationOrder.toLowerCase()}`;
  const isAsc = conversationOrder === 'ASC';
  const wrapperClass = [
    conversationClass,
    'chat-feed-container-styles hide-scroll border-bottom fhp scroll',
    !isAsc && 'flex col',
    isSafari && isAsc && 'flex col',
    'flex col'
  ]
    .filter(Boolean)
    .join(' ');

  const bubbleClassNames = [
    'feeds-container-wrapper flex col scroll pt20 pr0 pl0', // we have added margin top -30 as there will be an empty div by virtual list
    isAsc ? 'ch-90' : 'fhp'
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <StyledConversation
      className={wrapperClass}
      ref={chatFeedContainerRef}
      id="chat-feed-wrapper"
    >
      <div className={bubbleClassNames} ref={listRef}>
        {createdBubbleProp && renderCreatedBubble && (
          <CreatedByBubble message={createdBubbleProp} newLayout />
        )}

        {isEmpty(feedsToDisplay) ? (
          <TicketConversationEmptyState mode={conversationMode} />
        ) : (
          <div className="flex col g10 mtm20">
            <ViewportList
              viewportRef={listRef}
              items={feedsToDisplay}
              itemMinSize={100}
              initialPrerender={4}
              {...getExtraProps()}
            >
              {(el, index) => {
                const Component = Bubbles?.[el?.type];
                const BubbleProps = getBubbleProps(el?.type, el) || {};
                return (
                  <React.Fragment key={el?.id || index}>
                    {Component ? (
                      <Component
                        data={el}
                        tabIndex={-1}
                        ticketId={ticketId}
                        ticketSource={source}
                        key={el?.id || index}
                        showEmailSent={
                          (el?.type === 'CONVERSATION' &&
                            showEmailSent ===
                              el?.conversation?.conversationId) ||
                          (el?.type === 'THREAD_CONVERSATION' &&
                            showEmailSent ===
                              el?.threadConversation?.conversationId)
                        }
                        newLayout
                        readOnly={readOnly}
                        {...BubbleProps}
                      />
                    ) : (
                      // React virtual expect some render
                      // so we'll render an empty else older conversation won't load
                      <div id="hidden-bubble" className="hiddenActions"></div>
                    )}
                  </React.Fragment>
                );
              }}
            </ViewportList>
          </div>
        )}
      </div>

      {!readOnly && (
        <>
          {ticketConversationUx ? (
            <>
              <TicketConversationActions
                ticket={{
                  subject: subject,
                  ticketId: ticketId,
                  id: ticketId,
                  requester: requester,
                  client: client,
                  displayId: displayId,
                  source: source || null
                }}
              />
            </>
          ) : (
            <div className="bg-none">
              {isMSP && !flags?.unifiedRunbooks && (
                <ApprovalWidget
                  ticket={{
                    ticketId: ticketId,
                    id: ticketId,
                    requester: requester,
                    client: client,
                    sop: sop || null
                  }}
                />
              )}

              {conversationMode &&
              conversationTypeMap?.[conversationMode] &&
              !isActionContainerDisabled ? (
                <>
                  {conversationMode === conversationTypeMap.conversation &&
                    showTicketEditorContainer &&
                    requester && (
                      <ConversationEditorContainer
                        ticket={{
                          ticketId: ticketId,
                          id: ticketId,
                          requester: requester,
                          client: client,
                          sop: sop || null,
                          subject: subject,
                          displayId: displayId,
                          source: source || null,
                          additionalRequester: additionalRequester || null
                        }}
                        feeds={allFeedsRef.current}
                        mode={props?.mode}
                        resetConversationMode={resetConversationMode}
                        statusConfigData={
                          statusConfigData?.getStatusConfiguration
                        }
                        allStatuses={allStatus}
                        isStatusAuthorised={isStatusAuthorised}
                        isEditAuthorised={isEditAuthorised}
                        conversationOrder={conversationOrder}
                        updateTicketStatus={updateTicketStatus}
                        status={status}
                        refreshCount={refetchFeeds}
                        focusLastAddedMessage={focusLastAddedMessage}
                        concurrentUsersTyping={concurrentUsersTyping}
                        setFailureConversationData={setFailureConversationData}
                        setClosureModalActive={props?.setClosureModalActive}
                        setClosureSaveLoading={props?.setClosureSaveLoading}
                        setErrorsOnClosure={props?.setErrorsOnClosure}
                        updateTicketState={props?.updateTicketState}
                        sendAgentCollisionDataFromFloatingEditor={
                          sendAgentCollisionDataFromFloatingEditor
                        }
                        checkHideGlobalTicketConversationCloseModal={
                          checkHideGlobalTicketConversationCloseModal
                        }
                        checkIfActionToolbarDisabled={
                          checkIfActionToolbarDisabled
                        }
                        openTicketFromGlobalConversation={
                          openTicketFromGlobalConversation
                        }
                        prompts={AIPrompts}
                        sendAIFeatureFeedback={sendAIFeatureFeedback}
                        imConfig={imConfig}
                      />
                    )}

                  {isMSP && conversationMode === conversationTypeMap.note && (
                    <AccessControl
                      roleToCheck="ticketingAddNotes.allow"
                      render={
                        <>
                          <NoteEditorContainer
                            ticket={{
                              ticketId: ticketId,
                              id: ticketId,
                              requester: requester,
                              client: client,
                              sop: sop || null
                            }}
                            mode={props?.mode}
                            resetConversationMode={resetConversationMode}
                            conversationOrder={conversationOrder}
                            focusLastAddedMessage={focusLastAddedMessage}
                            prompts={AIPrompts}
                            sendAIFeatureFeedback={sendAIFeatureFeedback}
                          />
                        </>
                      }
                    />
                  )}
                </>
              ) : (
                <>
                  <ActionToolbar
                    onClick={onActionClick}
                    ticket={{
                      requester: requester
                    }}
                    createNewSideConversation={createNewSideConversation}
                    isMSP={isMSP}
                    intl={intl}
                    isDisabled={isActionContainerDisabled}
                  />
                </>
              )}
            </div>
          )}
        </>
      )}
    </StyledConversation>
  );
};

export default withErrorBoundary(ChatFeedContainerNew);
